import {IRange} from "@pg-design/range-module";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchFinancingPreference, HomeMatchPreferencesSurveyBuildingHeight} from "../constants/preferences/home_match_preferences_values";
import {IHomeMatchPreferencesSurveyForm, IHomeMatchSurveyApiRequest} from "../types/home_match_preferences";
import {getHomeMatchPricePatch, getHomeMatchRegionIds} from "./get_home_match_preferences_wizard_step_patch";
import {toHomeMatchFloorNumbers} from "./home_match_floors_preference";
import {getHomeMatchRoomsPatch} from "./home_match_rooms_range";
import {parseRangeBound} from "./parse_range_bound";

const PRIMARY_MARKET = 1;
const SECONDARY_MARKET = 2;

interface IParams {
    additionalExpectationsDirty: boolean;
    areaDirty: boolean;
    buildingHeightDirty: boolean;
    constructionEndDateDirty: boolean;
    floorsPreferenceDirty: boolean;
    form: IHomeMatchPreferencesSurveyForm;
    propertyTypeDirty: boolean;
    secondaryMarketDirty: boolean;
    source: PreferencesSurveySource;
}

/** The area is optional, and so is each of its bounds: an empty bound is sent as unset, both empty clear the area. */
const toArea = (area: IHomeMatchPreferencesSurveyForm["area"]): IRange<number | null> | null => {
    const lower = parseRangeBound(area.lower) ?? null;
    const upper = parseRangeBound(area.upper) ?? null;

    if (lower == null && upper == null) return null;

    return {lower, upper};
};

const toBuildingHeightPatch = (buildingHeight: IHomeMatchPreferencesSurveyForm["buildingHeight"]) => {
    if (buildingHeight === HomeMatchPreferencesSurveyBuildingHeight.HIGH) {
        return {high_rise_buildings: true, low_rise_buildings: null};
    }

    if (buildingHeight === HomeMatchPreferencesSurveyBuildingHeight.LOW) {
        return {high_rise_buildings: null, low_rise_buildings: true};
    }

    return {high_rise_buildings: null, low_rise_buildings: null};
};

export const buildHomeMatchPreferencesSurveyPatch = (params: IParams): IHomeMatchSurveyApiRequest => {
    const {
        additionalExpectationsDirty,
        areaDirty,
        buildingHeightDirty,
        constructionEndDateDirty,
        floorsPreferenceDirty,
        form,
        propertyTypeDirty,
        secondaryMarketDirty,
        source
    } = params;
    const financingPreference = form.financing ?? undefined;

    const body: IHomeMatchSurveyApiRequest = {
        financing_services: financingPreference === HomeMatchFinancingPreference.CREDIT,
        price: getHomeMatchPricePatch(form.price),
        regions: getHomeMatchRegionIds(form.regions),
        rooms: getHomeMatchRoomsPatch(form.rooms),
        source,
        ...(financingPreference ? {financing_preference: financingPreference} : {})
    };

    if (propertyTypeDirty) {
        body.types = form.propertyType == null ? null : [form.propertyType];
    }

    if (areaDirty) {
        body.area = toArea(form.area);
    }

    if (constructionEndDateDirty) {
        body.construction_end_date = form.constructionEndDate;
    }

    if (floorsPreferenceDirty) {
        if (form.floorsPreference.length > 1) {
            body.floor_numbers = toHomeMatchFloorNumbers(form.floorsPreference);
            body.floors_preference = null;
        } else {
            body.floors_preference = form.floorsPreference[0] ?? null;
            body.floor_numbers = null;
        }
    }

    if (buildingHeightDirty) {
        const buildingHeight = toBuildingHeightPatch(form.buildingHeight);

        body.high_rise_buildings = buildingHeight.high_rise_buildings;
        body.low_rise_buildings = buildingHeight.low_rise_buildings;
    }

    if (additionalExpectationsDirty) {
        body.additional_areas = form.additionalExpectations.length ? form.additionalExpectations : null;
    }

    if (secondaryMarketDirty) {
        body.market_types = form.secondaryMarket ? [PRIMARY_MARKET, SECONDARY_MARKET] : [PRIMARY_MARKET];
    }

    return body;
};
import {IRange} from "@pg-design/range-module";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchFinancingPreference, HomeMatchPreferencesSurveyBuildingHeight} from "../constants/preferences/home_match_preferences_values";
import {IHomeMatchPreferencesSurveyForm, IHomeMatchSurveyApiRequest} from "../types/home_match_preferences";
import {getHomeMatchPricePatch, getHomeMatchRegionIds} from "./get_home_match_preferences_wizard_step_patch";
import {toHomeMatchFloorNumbers} from "./home_match_floors_preference";
import {getHomeMatchRoomsPatch} from "./home_match_rooms_range";
import {parseRangeBound} from "./parse_range_bound";

const PRIMARY_MARKET = 1;
const SECONDARY_MARKET = 2;

interface IParams {
    additionalExpectationsDirty: boolean;
    areaDirty: boolean;
    buildingHeightDirty: boolean;
    constructionEndDateDirty: boolean;
    floorsPreferenceDirty: boolean;
    form: IHomeMatchPreferencesSurveyForm;
    propertyTypeDirty: boolean;
    secondaryMarketDirty: boolean;
    source: PreferencesSurveySource;
}

/** The area is optional, and so is each of its bounds: an empty bound is sent as unset, both empty clear the area. */
const toArea = (area: IHomeMatchPreferencesSurveyForm["area"]): IRange<number | null> | null => {
    const lower = parseRangeBound(area.lower) ?? null;
    const upper = parseRangeBound(area.upper) ?? null;

    if (lower == null && upper == null) return null;

    return {lower, upper};
};

const toBuildingHeightPatch = (buildingHeight: IHomeMatchPreferencesSurveyForm["buildingHeight"]) => {
    if (buildingHeight === HomeMatchPreferencesSurveyBuildingHeight.HIGH) {
        return {high_rise_buildings: true, low_rise_buildings: null};
    }

    if (buildingHeight === HomeMatchPreferencesSurveyBuildingHeight.LOW) {
        return {high_rise_buildings: null, low_rise_buildings: true};
    }

    return {high_rise_buildings: null, low_rise_buildings: null};
};

export const buildHomeMatchPreferencesSurveyPatch = (params: IParams): IHomeMatchSurveyApiRequest => {
    const {
        additionalExpectationsDirty,
        areaDirty,
        buildingHeightDirty,
        constructionEndDateDirty,
        floorsPreferenceDirty,
        form,
        propertyTypeDirty,
        secondaryMarketDirty,
        source
    } = params;
    const financingPreference = form.financing ?? undefined;

    const body: IHomeMatchSurveyApiRequest = {
        financing_services: financingPreference === HomeMatchFinancingPreference.CREDIT,
        price: getHomeMatchPricePatch(form.price),
        regions: getHomeMatchRegionIds(form.regions),
        rooms: getHomeMatchRoomsPatch(form.rooms),
        source,
        ...(financingPreference ? {financing_preference: financingPreference} : {})
    };

    if (propertyTypeDirty) {
        body.types = form.propertyType == null ? null : [form.propertyType];
    }

    if (areaDirty) {
        body.area = toArea(form.area);
    }

    if (constructionEndDateDirty) {
        body.construction_end_date = form.constructionEndDate;
    }

    if (floorsPreferenceDirty) {
        if (form.floorsPreference.length > 1) {
            body.floor_numbers = toHomeMatchFloorNumbers(form.floorsPreference);
            body.floors_preference = null;
        } else {
            body.floors_preference = form.floorsPreference[0] ?? null;
            body.floor_numbers = null;
        }
    }

    if (buildingHeightDirty) {
        const buildingHeight = toBuildingHeightPatch(form.buildingHeight);

        body.high_rise_buildings = buildingHeight.high_rise_buildings;
        body.low_rise_buildings = buildingHeight.low_rise_buildings;
    }

    if (additionalExpectationsDirty) {
        body.additional_areas = form.additionalExpectations.length ? form.additionalExpectations : null;
    }

    if (secondaryMarketDirty) {
        body.market_types = form.secondaryMarket ? [PRIMARY_MARKET, SECONDARY_MARKET] : [PRIMARY_MARKET];
    }

    return body;
};
